
import React from 'react'
import BlockAlignment from './BlockAlignment'

export default BlockAlignment
